/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSideBarProps, TdSideBarItemProps } from './type';

export const sideBarDefaultProps: TdSideBarProps = { defaultValue: undefined };

export const sideBarItemDefaultProps: TdSideBarItemProps = { disabled: false };
